// extracted by mini-css-extract-plugin
export default {"mapPage":"map-page_mapPage__rhyJk"};